export default "__VITE_ASSET__DdwlHnQa__"